module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_07_beach-photo-1a6a14339f9364c0c191d4fd3aa7503b.jpg";